import script from "./InformationSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationSection.vue?vue&type=script&lang=ts&setup=true"

import "./InformationSection.vue?vue&type=style&index=0&id=4374c3be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4374c3be"]])

export default __exports__